import { render, staticRenderFns } from "./RealTaskManagement.vue?vue&type=template&id=e040eb90&"
import script from "./RealTaskManagement.vue?vue&type=script&lang=js&"
export * from "./RealTaskManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports